export const transferForm = {
	loadingTargetPlaceData: "Cargando datos del place de destino...",
	reviewLabels: {
		balanceAfterTransferAtSourcePlace:
			"Saldo después de transferencia en el place de origen",
		balanceAfterTransferAtTargetPlace:
			"Saldo después de transferencia en el place de destino",
	},
	submitFailedMessage: "No fue posible transferir el valor",
	submitSucceededMessage: "Valor transferido con éxito",
	transferTotalValueBtn: "Transferir todo saldo disponible",
	balanceAvailable: "Saldo disponible",
	enoughBalanceMessage: "Saldo disponible para transferencia",
	selectPlaceLabel: "Seleccione el place de destino",
	selectPlacePlaceholder: "Seleccione el place que recibirá la transferencia",
	wizardLabels: {
		target: "Destino",
		value: "Valor de la transferencia",
		review: "Revisión de los datos",
	},
};
